module.exports = __webpack_public_path__ + "static/media/bck1.aba1076b.mp3";